import { useEffect } from 'react';
import type { CanvasState } from './useCanvasTransform';

export function useWheelZoom(
  canvasRef: React.RefObject<HTMLCanvasElement>,
  setCanvasState: React.Dispatch<React.SetStateAction<CanvasState>>
) {
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const handleWheel = (e: WheelEvent) => {
      e.preventDefault();
      const rect = canvas.getBoundingClientRect();
      const mouseX = e.clientX - rect.left;
      const mouseY = e.clientY - rect.top;
      const zoomFactor = e.deltaY > 0 ? 0.9 : 1.1;
      setCanvasState(prev => {
        const newScale = Math.max(0.1, Math.min(8, prev.scale * zoomFactor));
        const scaleRatio = newScale / prev.scale;
        const newOffsetX = mouseX - (mouseX - prev.offset.x) * scaleRatio;
        const newOffsetY = mouseY - (mouseY - prev.offset.y) * scaleRatio;
        return {
          scale: newScale,
          offset: { x: newOffsetX, y: newOffsetY },
          zoomPercentage: Math.round(newScale * 100)
        };
      });
    };

    canvas.addEventListener('wheel', handleWheel, { passive: false });
    return () => canvas.removeEventListener('wheel', handleWheel);
  }, [canvasRef, setCanvasState]);
}


